/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The SiteReferrerOption model module.
 * @module model/SiteReferrerOption
 * @version 1.0.0
 */
export default class SiteReferrerOption {
  /**
   * Constructs a new <code>SiteReferrerOption</code>.
   * @alias module:model/SiteReferrerOption
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>SiteReferrerOption</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SiteReferrerOption} obj Optional instance to populate.
   * @return {module:model/SiteReferrerOption} The populated <code>SiteReferrerOption</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SiteReferrerOption()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String')
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {String} name
   */
  name = undefined
}
